import angular from 'angular'
import uiRouter from 'angular-ui-router'
import uiBootstrap from 'angular-ui-bootstrap'
import cancelComponent from './cancel.component'
import stModal from '../../../../common/stModal/stModal'

const cancelModule = angular.module('cancel', [
    uiRouter,
    uiBootstrap,
    stModal
])
    .config(($stateProvider) => {
        "ngInject";
        $stateProvider
            .state('bookings.booking.cancel', {
                url: '/cancel',
                resolve: {
                    data: function (myBookingService, $stateParams, $q, authService, $state) {
                        return $q.all({
                            amend: myBookingService.getAmend($stateParams.bookingReference),
                            cancel: myBookingService.getCancel($stateParams.bookingReference)
                        }).then((result) => {
                            for (var id in result.cancel.transfers) {
                                angular.merge(result.cancel.transfers[id], result.amend.transfers[id]);
                            }
                            return result.cancel;
                        }, function (error) {
                            if (error.status === 401) {
                                authService.clearSession();
                                $state.go('auth.login');
                            }
                            return null;
                        });
                    }
                },
                views: {
                    'booking@bookings.booking': {
                        template: '<cancel cancel="$resolve.data"></cancel>'
                    }
                }
            })
    })
    .component('cancel', cancelComponent)
    .name

export default cancelModule


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/cancel/cancel.js